import { React, useEffect, useState } from "react";
import { Button, Form, Input, Select, Col, Row, Checkbox, Radio } from "antd";
import warning from "../../../Assets/Icons/warning.png";
import Iconmoon from "../../../Components/IconsFiles/icon";
import {
  HaberForm,
  RightDrawerContainer,
  DownArrowDraw,
  DetailFields,
  DropDownSearchDraw
} from "../../styledElements";
import RightDrawerSidebar from "../../../Components/RightDrawer/rightDrawer";
import { DatePicker } from "antd";
import { DatePickerY } from "../../pageStyled";
import { getAllOrdersListByOrderno, saveSplitOrder, sheetMatchingSplitOrder } from "../../../Services/orderServices";
import moment from "moment";
import { getProductDetails } from "../../../Services/productServices";
import { getCustomerDetails } from "../../../Services/customerServices";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import { ModalPopup } from "../../../Components/Modal/modal";
import { Collapse } from 'antd';
import { getUnitData } from "../../../Services/measurementService";
import { weightUnit, weight_Unit_Conversions, orderDim_Rewinder_Unit_Conversion, conversionFactorUnitsToTonne, conversionFactorTonneToUnits, CoversionFactorUnitsToCM, lengthUnit } from "../../../Utils/Constant/MeasurementUnitList";

const capitalize = (item) => item.charAt(0).toUpperCase() + item.slice(1);
const { Option } = Select;
const { TextArea } = Input;
const { Panel } = Collapse;
const SplitOrderDrawer = (props) => {
    const [orderDetails, setOrderDetails] = useState();
    const [orderNo, setOrderNo] = useState("");
    const [form] = Form.useForm();
    const [pendingQuantity, setPendingQuantity] = useState();
    const [splitQuantity, setSplitQuantity] = useState();
    const [splitQuantityValidationError, setSplitQuantityValidationError] = useState(false);
    const [splitQuantError, setSplitQuantError] = useState(false);
    const [splitQuantityWeightValidationError, setSplitWeightValidationError] = useState(false);
    const [splitQuantityWghtValidationError, setSplitQuantityWeightValidationError] = useState(false);
    const [coreOdValidationError, setCoreOdValidationError] = useState(false);
    const [rewinderDia, setRewinderDia] = useState(false);
    const [numberOfPlannedReels , setPlannedReels] = useState("");
    const [reelCoreOD, setReelCoreOD] = useState(false);
    const [customerDetails, setCustomerDetails] = useState();
    const [productData, setProductData] = useState({});
    const deckleWidthUnitData = ["mm", "cm"];
    const [orderQuantityTab, setOrderQuantityTab] = useState();
    const [pendingQuantityIsZero, setPendingQuantityIsZero] = useState(false);
    const [actionToaster, setActionToaster] = useState({
        error: "",
        msg: "",
      });
    const [visibleToaster, setVisibleToaster] = useState(false);
    const [isVisibleModal, setIsVisibleModal] = useState(false);
    const [reqBody, setReqBody] = useState();
    const [upperTolerance, setUpperTolerance] = useState("");
    const [lowerTolerance, setLowerTolerance] = useState("");
    const [defaultUpperTol, setDefaultUpperTol] = useState("");
    const [defaultLowerTol, setDefaultLowerTol] = useState("");
    const [plannedWeight, setPlannedWeight] = useState("");
    const [weightUnitList, setWeightUnitList] = useState([]);
    const [unitPlaceholder, setUnitPlaceholder] = useState("");
    const [measurementData, setMeasurementData] = useState();
    const [rewinderDimUnitList, setReiwnderDimUnitList] = useState([]);
    const [netPriceValue, setNetPriceValue] = useState("");

    const validateSplitQuantity = (e) => {
      if (e.target.value == "0" || e.target.value === "") {
        setSplitQuantityValidationError(true);
          setPlannedReels("");
          setPlannedWeight(0.000);
          form.setFieldsValue({ no_of_reel_sheet: ""});
          form.setFieldsValue({ planned_weight: 0.000 });
      } else if(e.target.value > (parseFloat(form.getFieldValue("pendingReels")))) {
        setSplitQuantError(true);
      } else{
        setSplitQuantityValidationError(false);
        setSplitQuantError(false);
        calculatePlannedReels();
      }
    };

    const validateSplitWeight = (e) => {
      setSplitWeightValidationError(false);
      setSplitQuantityWeightValidationError(false);
      let weightUnitValue = form.getFieldValue("weightUnit");
      let splitWeightValue = e.target.value * weight_Unit_Conversions[weightUnitValue];
      let pendingQuantityValue = form.getFieldValue("pendingWeight") * weight_Unit_Conversions[orderDetails?.units?.weight];
      if (e.target.value == "0" || e.target.value === ""){
        setSplitQuantityWeightValidationError(true);
          setPlannedReels("");
          setPlannedWeight(0.00);
          form.setFieldsValue({ no_of_reel_sheet: ""});
          form.setFieldsValue({ planned_weight: 0.000 });
      } else if(parseFloat(splitWeightValue) > (parseFloat(pendingQuantityValue))) {
        setSplitWeightValidationError(true);
        setPlannedReels("");
          setPlannedWeight(0.00);
          form.setFieldsValue({ no_of_reel_sheet: ""});
          form.setFieldsValue({ planned_weight: 0.000 });
      } else{
        setSplitQuantityWeightValidationError(false);
        setSplitWeightValidationError(false);
        calculatePlannedReels();
      }
    };

    const onChangeWeightUnit = (e) => {
      setSplitWeightValidationError(false);
      setSplitQuantityWeightValidationError(false);
      let weightValue = form.getFieldValue("splitWeight");
      let splitWeightValue = weightValue * weight_Unit_Conversions[e];
      let pendingQuantityValue = form.getFieldValue("pendingWeight") * weight_Unit_Conversions[orderDetails?.units?.weight];
      if (weightValue == "0" || weightValue === ""){
        setSplitQuantityWeightValidationError(true);
        setPlannedReels("");
        setPlannedWeight(0.00);
        form.setFieldsValue({ no_of_reel_sheet: ""});
        form.setFieldsValue({ planned_weight: 0.000 });
      } else if(parseFloat(splitWeightValue) > (parseFloat(pendingQuantityValue))) {
        setSplitWeightValidationError(true);
        setPlannedReels("");
        setPlannedWeight(0.00);
        form.setFieldsValue({ no_of_reel_sheet: ""});
        form.setFieldsValue({ planned_weight: 0.000 });
      } else{
        setSplitQuantityWeightValidationError(false);
        setSplitWeightValidationError(false);
        calculatePlannedReels();
      }
      setUnitPlaceholder(e);
    };

    const calculatePlannedReels = () => {
        let splitWeight = form.getFieldValue("splitWeight");
        let splitQuantityValue = form.getFieldValue("splitQuantity");
        let reelOD = form.getFieldValue("reel_od");
        let coreOD = form.getFieldValue("core_od");
        let size;
        if(reelOD === ""){
          reelOD = 0;
        }
        if(coreOD === ""){
          coreOD = 0;
        }
        if(orderDetails?.type === "sheet"){
            size = orderDetails?.grain === "short" ? (parseFloat(orderDetails?.length) > parseFloat(orderDetails?.width) ? orderDetails?.length : orderDetails?.width) 
                : (parseFloat(orderDetails?.length) > parseFloat(orderDetails?.width) ? orderDetails?.width : orderDetails?.length);
        } else{
            size = orderDetails?.width;
        }

        let rewinderUnit = form.getFieldValue("unit");
        let rewinderUnitValue = orderDim_Rewinder_Unit_Conversion[rewinderUnit];
        let dimensionUnit = orderDim_Rewinder_Unit_Conversion[orderDetails.units?.width];
        let weightUnit = form.getFieldValue("weightUnit");
        let weightUnitValue = weight_Unit_Conversions[weightUnit];

        if(orderDetails?.type === "reel" && splitQuantity === "reel"){
            form.setFieldsValue({no_of_reel_sheet: splitQuantityValue});
            // calculatePlannedWeight(size, productData?.bulk, reelOD, coreOD, splitQuantityValue);
            setPlannedReels(splitQuantityValue);
        } else{
          if(reelOD && coreOD){
            const value = splitQuantity === "weight" ? (parseFloat(splitWeight * weightUnitValue) * 1000 * 1000 * parseFloat(productData?.bulk) * 4) /
              (3.14 * parseFloat(size * dimensionUnit) * (Math.pow(parseFloat(reelOD * rewinderUnitValue), 2) - Math.pow(parseFloat(coreOD * rewinderUnitValue), 2)))
            : (parseFloat(orderDetails?.length * dimensionUnit) * parseFloat(orderDetails?.width * dimensionUnit) * parseFloat(splitQuantityValue) * parseFloat(productData?.gsm) * parseFloat(productData?.bulk) * 4) / 
                (3.14 * parseFloat(size * dimensionUnit) * (Math.pow(parseFloat(reelOD * rewinderUnitValue), 2) - Math.pow(parseFloat(coreOD * rewinderUnitValue), 2)) * 10000);
            form.setFieldsValue({ no_of_reel_sheet: Math.round(value.toFixed(2)) ? Math.round(value.toFixed(2)) : 1 });
            setPlannedReels(value.toFixed(2));
          }else{
            if(splitQuantity === "weight" && orderDetails?.type === "sheet"){
              let weightValue = form.getFieldValue("splitWeight");
              setPlannedReels("");
              setPlannedWeight(weightValue);
              form.setFieldsValue({ no_of_reel_sheet: ""});
              form.setFieldsValue({ planned_weight: parseFloat(weightValue)?.toFixed(3) });
            } else if(splitQuantity === "sheet" && orderDetails?.type === "sheet"){
              const value = ((parseFloat(orderDetails?.length * dimensionUnit) * parseFloat(orderDetails?.width * dimensionUnit) * parseFloat(splitQuantityValue) * parseFloat(productData?.gsm)) / (10000 * 1000000));
              if(value){
                let weightUnit = form.getFieldValue("weightUnit");
                let plannedWeightValue = value * conversionFactorTonneToUnits[weightUnit];
                setPlannedWeight(plannedWeightValue ? plannedWeightValue.toFixed(3) : 0);
                form.setFieldsValue({planned_weight: plannedWeightValue ? plannedWeightValue.toFixed(3) : 0});
                setPlannedReels("");
                form.setFieldsValue({ no_of_reel_sheet: ""});
              } else{
                setPlannedReels("");
                setPlannedWeight("");
                form.setFieldsValue({ no_of_reel_sheet: ""});
                form.setFieldsValue({ planned_weight: "" });
              }              
            } else{
              setPlannedReels("");
              setPlannedWeight("");
              form.setFieldsValue({ no_of_reel_sheet: ""});
              form.setFieldsValue({ planned_weight: "" });
            }
          }
        }
    }

    const handleClose = () => {
      form.resetFields();
      setReelCoreOD(false);
      setPlannedReels("");
      setPlannedWeight("");
      setOrderDetails();
      setOrderNo("");
      props.onClose();
      props.onCloseGrade();
      setPendingQuantityIsZero(false);
      setSplitQuantityValidationError(false);
      setCoreOdValidationError(false);
      setSplitQuantityWeightValidationError(false);
      setSplitWeightValidationError(false);
      props.setDrawer(false);
      setMeasurementData();
      setNetPriceValue("");
    };

    const onChangeCoreUnit = (e) => {
      let reelOD = form.getFieldValue("reel_od");
      let coreOD = form.getFieldValue("core_od");
      if(orderDetails?.type === "reel" && splitQuantity === "reel"){              
        if(reelOD === ""){
          reelOD = 0;
        }
        if(coreOD === ""){
          coreOD = 0;
        }
        let size = orderDetails?.width;
        let splitQuantityValue = form.getFieldValue("splitQuantity");
        let rewinderDimUnit = orderDim_Rewinder_Unit_Conversion[e];
        let dimensionUnit = orderDim_Rewinder_Unit_Conversion[orderDetails.units?.width];
        calculatePlannedWeight(
          size * dimensionUnit,
          productData?.bulk, 
          reelOD * rewinderDimUnit,
          coreOD * rewinderDimUnit, 
          splitQuantityValue);
      } else{
        calculatePlannedReels();
      }
    };

    const onNoOfReelSheetChange = (e) => {
      let noOfReels;
      if(e.target.value.trim() == ""){
        noOfReels = 0;
      } else{
        noOfReels = e.target.value;
      }
      let size;
      if(orderDetails?.type === "sheet"){
      size = orderDetails?.grain === "short" ? (orderDetails?.length > orderDetails?.width ? orderDetails?.length : orderDetails?.width) 
                : (orderDetails?.length > orderDetails?.width ? orderDetails?.width : orderDetails?.length);

    } else{
        size = orderDetails?.width;
    }
      let reelOD = form.getFieldValue("reel_od");
      let coreOD = form.getFieldValue("core_od");
      if(reelOD && coreOD){
        calculatePlannedWeight (size, productData?.bulk, reelOD, coreOD, noOfReels);
      }
    }

    const calculatePlannedWeight = (size, bulk, reelOd, coreOd, plannedReels) => {
      if(size && bulk && reelOd && coreOd && plannedReels){
        let sizeUnit = orderDetails?.units?.width;
        let rewinderDimUnit = form.getFieldValue("unit");
        size = size * CoversionFactorUnitsToCM[sizeUnit];
        reelOd = reelOd * CoversionFactorUnitsToCM[rewinderDimUnit];
        coreOd = coreOd * CoversionFactorUnitsToCM[rewinderDimUnit];
        const value = (3.14 * parseFloat(size) * (Math.pow(parseFloat(reelOd), 2) - Math.pow(parseFloat(coreOd), 2)) *
        parseFloat(plannedReels)) / (1000 * 1000 * parseFloat(bulk) * 4);
        
        let weightUnit = form.getFieldValue("weightUnit");
        let plannedWeightValue = value * conversionFactorTonneToUnits[weightUnit];
        setPlannedWeight(plannedWeightValue ? plannedWeightValue.toFixed(3) : 0);
        form.setFieldsValue({planned_weight: plannedWeightValue ? plannedWeightValue.toFixed(3) : 0});
      } else{
        form.setFieldsValue({planned_weight: ""});
        setPlannedWeight("");
      }
    }

    const calculatePendingQuantity = (value) => {
    setPendingQuantityIsZero(false);
    if(orderDetails && orderDetails?.type){
      if((form.getFieldValue("core_id") && form.getFieldValue("reel_od")) || (orderDetails?.core_id && orderDetails?.reel_od)){
        const numberOfProcessedReels = orderDetails?.in_process + orderDetails?.in_production + orderDetails?.completed;
        let size;
          if(orderDetails?.type === "sheet"){
            size = orderDetails?.grain === "short" ? (orderDetails?.length > orderDetails?.width ? orderDetails?.length : orderDetails?.width) 
                : (orderDetails?.length > orderDetails?.width ? orderDetails?.width : orderDetails?.length);
          } else{
              size = orderDetails?.width;
          }
          
          const processedReelsWeight = (3.14 * size * (Math.pow(orderDetails?.reel_od, 2) -  Math.pow(orderDetails?.core_id, 2)) * numberOfProcessedReels) / (1000 * 1000 * productData?.bulk * 4);
          
          if((orderDetails?.quantity_type === "weight") && (orderDetails?.type === "reel" || orderDetails?.type === "sheet")){
            const pendingWeightValue = orderDetails?.weight - processedReelsWeight;
            if(!pendingWeightValue){
                setPendingQuantityIsZero(true);
            }
            form.setFieldsValue({pendingWeight: pendingWeightValue.toFixed(3)});
          } else if(orderDetails?.quantity_type === "reel_sheet" && orderDetails?.type === "reel"){
            const pendingReelValue = orderDetails?.no_of_reel_sheet - numberOfProcessedReels;
            if(!pendingReelValue){
              setPendingQuantityIsZero(true);
            }
            form.setFieldsValue({pendingReels: Math.round(pendingReelValue)});
          } else {
            if(orderDetails?.length && orderDetails?.width && productData?.gsm){
              let processedSheets = processedReelsWeight / ((orderDetails?.length * orderDetails?.width * productData?.gsm) / Math.pow(10, 10));
              let pendingSheetValue = orderDetails?.no_of_reel_sheet - processedSheets;
              if(!pendingSheetValue){
                  setPendingQuantityIsZero(true);
              }
              form.setFieldsValue({pendingReels: Math.round(pendingSheetValue)});
              // let orderWeight = ((orderDetails?.no_of_reel_sheet * orderDetails?.length * orderDetails?.width * productData?.gsm) / Math.pow(10, 10));
              // let pendingSheetValue = orderWeight - processedReelsWeight;
              // if(!pendingSheetValue){
              //   setPendingQuantityIsZero(true);
              // }
              // form.setFieldsValue({pendingWeight: pendingSheetValue.toFixed(2)});
            } else{
              form.setFieldsValue({pendingReels: 0});
              setPendingQuantityIsZero(true);
            }
          }
      } else{
        if(orderDetails?.type === "sheet"){
          if(orderDetails?.quantity_type === "reel_sheet"){
            if(productData?.gsm){
              let pendingSheetValue = (((orderDetails?.pending_quantity_weight * conversionFactorUnitsToTonne[orderDetails?.units?.planned_weight]) * (10000 * 1000000)) / 
              ((orderDetails?.length * CoversionFactorUnitsToCM[orderDetails?.units?.width]) * (orderDetails?.width * CoversionFactorUnitsToCM[orderDetails?.units?.width]) * productData?.gsm));
              pendingSheetValue ?  setPendingQuantityIsZero(false) :  setPendingQuantityIsZero(true);
              form.setFieldsValue({pendingReels: Math.round(pendingSheetValue)});
            } else{
              setPendingQuantityIsZero(true);
              form.setFieldsValue({pendingReels: 0});
            }
          } else{
            form.setFieldsValue({pendingWeight: orderDetails?.pending_quantity_weight?.toFixed(3)});
          }
        }
      }
    }
    }

    const validateReelOd = (e) => {
        let reelOD = e.target.value;
        let coreOD = form.getFieldValue("core_od");
        if(parseFloat(e.target.value) < coreOD){
            setCoreOdValidationError(true);
        } else{
            setCoreOdValidationError(false);
            if(orderDetails?.type === "reel" && splitQuantity === "reel"){              
              if(reelOD === ""){
                reelOD = 0;
              }
              if(coreOD === ""){
                coreOD = 0;
              }
              let size = orderDetails?.width;
              let splitQuantityValue = form.getFieldValue("splitQuantity");
              calculatePlannedWeight(size, productData?.bulk, reelOD, coreOD, splitQuantityValue);
            } else{
              calculatePlannedReels();
            }
        }
    };

    const validateCoreOd = (e) => {
        let coreOD = e.target.value;
        let reelOD = form.getFieldValue("reel_od");
        if (parseFloat(e.target.value) > reelOD) {
          setCoreOdValidationError(true);
        } else {
          setCoreOdValidationError(false);
          if(orderDetails?.type === "reel" && splitQuantity === "reel"){
            if(reelOD === ""){
              reelOD = 0;
            }
            if(coreOD === ""){
              coreOD = 0;
            }
            let size = orderDetails?.width;
            let splitQuantityValue = form.getFieldValue("splitQuantity");
            calculatePlannedWeight(size, productData?.bulk, reelOD, coreOD, splitQuantityValue);
          } else{
            calculatePlannedReels();
          }
      }
    };

    const showToaster = () => {
        setVisibleToaster(true);
        setTimeout(() => setVisibleToaster(false), 3000);
      };

    const onFinish = (e) => {
      // props.onClose();
      // form.resetFields();
      let upper_tolerance_value = form.getFieldValue("upper_tolerance") && !e.core_od && !e.reel_od && orderDetails?.type === "sheet" ? form.getFieldValue("upper_tolerance") : 0;
      let lower_tolerance_value = form.getFieldValue("lower_tolerance") && !e.core_od && !e.reel_od && orderDetails?.type === "sheet" ? form.getFieldValue("lower_tolerance") : 0;
      if(!splitQuantityValidationError && !splitQuantityWeightValidationError 
        && !splitQuantityWghtValidationError && !coreOdValidationError){
          const body = {
            order: orderNo,
            split_order_data : {
                product_spec: orderDetails?.product_spec,
                type: orderDetails?.type,
                length: orderDetails?.length,
                width: orderDetails?.width,
                allow_partial_fulfillment: orderDetails?.allow_partial_fulfillment,
                delivery_date: e.delivery_date ? new Date(e.delivery_date).getFullYear() + "-" + (new Date(e.delivery_date).getMonth() + 1) + "-" + new Date(e.delivery_date).getDate() + "T00:00:00Z" : "",
                delivery_address_line_1: orderDetails?.delivery_address_line_1,
                delivery_address_line_2: orderDetails?.delivery_address_line_2,
                delivery_city: orderDetails?.delivery_city,
                delivery_state: orderDetails?.delivery_state,
                delivery_country: orderDetails?.delivery_country,
                delivery_pincode: orderDetails?.delivery_pincode,
                quoted_price: orderDetails?.quoted_price,
                net_price: netPriceValue,
                currency: orderDetails?.currency,
                po: orderDetails?.po,
                customer: orderDetails?.customer,
                product: orderDetails?.product,                
                forced: orderDetails?.forced,
                remarks: e.remarks,
                core_id: e.core_od? e.core_od : 0,
                reel_od: e.reel_od? e.reel_od : 0,
                quantity_type: splitQuantity === "weight" ? "weight" : "reel_sheet",
                ...(splitQuantity === "weight" && { weight:  e.splitWeight? parseFloat( e.splitWeight) : 0}),
                ...(splitQuantity !== "weight" && {
                  no_of_reel_sheet: e.splitQuantity ? Math.round(parseFloat(e.splitQuantity)) : 0,
                }),
                quantity: e.no_of_reel_sheet? e.no_of_reel_sheet : 0,
                planned_weight: e.planned_weight ? e.planned_weight : 0,
                upper_tolerance: upper_tolerance_value,
                lower_tolerance: lower_tolerance_value,
                calculated_upper_tolerance: upperTolerance && !e.core_od && !e.reel_od && orderDetails?.type === "sheet" ? upperTolerance : 0,
                calculated_lower_tolerance: lowerTolerance && !e.core_od && !e.reel_od && orderDetails?.type === "sheet" ? lowerTolerance : 0,
                units:{
                  weight: e.weightUnit,
                  ...orderDetails.type === "sheet" && {length: orderDetails.units.length},
                  width: orderDetails.units.width,
                  planned_weight: unitPlaceholder,
                  ...upperTolerance && !e.core_od && !e.reel_od && orderDetails?.type === "sheet" && {calculated_upper_tolerance: unitPlaceholder},
                  ...upperTolerance && !e.core_od && !e.reel_od && orderDetails?.type === "sheet" && {calculated_lower_tolerance: unitPlaceholder},
                  core_id: e.unit,
                  reel_od: e.unit,
                  quoted_price: orderDetails.units.quoted_price,
                  net_price: orderDetails.units.net_price,
                  per_weight_unit: orderDetails.units.per_weight_unit,
                }
            }
          };
          setReqBody(body);
          setIsVisibleModal(true);
      }
    };

    const modalConfirm = async () => {
      setIsVisibleModal(false);
      if(reqBody){
        if(form.getFieldValue("core_od") && form.getFieldValue("reel_od")){
          saveSplitOrder(reqBody).then((response) => {
                  props.toasterAction({
                    error: response.error,
                    msg: "The order " + orderNo + " is successfully split",
                  });
                  props.showToaster();
                  props.rendering(true);
                  props.onClose();
                  form.resetFields();
          })
          .catch((error) => {
            form.resetFields();
            setPlannedReels("");
            setPlannedWeight("");
            setReelCoreOD(false);
            setUpperTolerance("");
            setLowerTolerance("");
            setDefaultLowerTol("");
            setDefaultUpperTol("");
            setMeasurementData();
            setNetPriceValue("");
            console.log("Error in splitting order:", error);
          });
        } else if(!form.getFieldValue("core_od") && !form.getFieldValue("reel_od") && orderDetails?.type === "sheet"){
          sheetMatchingSplitOrder(reqBody).then((response) => {
            props.toasterAction({
              error: response.error,
              msg: "The order " + orderNo + " is successfully split",
            });
            props.showToaster();
            props.rendering(true);
            props.onClose();
            form.resetFields();
        })
        .catch((error) => {
          form.resetFields();
          setPlannedReels("");
          setPlannedWeight("");
          setReelCoreOD(false);
          setUpperTolerance("");
          setLowerTolerance("");
          setDefaultLowerTol("");
          setDefaultUpperTol("");
          setMeasurementData();
          setNetPriceValue("");      
          console.log("Error in splitting order:", error);
        });
      }
     }
    };

    const modalClose = () => {
      setIsVisibleModal(false);
      setReelCoreOD(false);
      form.resetFields();
      setPlannedReels("");
      setPlannedWeight("");
      setOrderDetails();
      setOrderNo("");      
      setUpperTolerance("");
      setLowerTolerance("");
      setDefaultLowerTol("");
      setDefaultUpperTol("");
      props.onClose();
      props.onCloseGrade();
      setPendingQuantityIsZero(false);
      setSplitQuantityValidationError(false);
      setCoreOdValidationError(false);
      setSplitQuantityWeightValidationError(false);
      setSplitWeightValidationError(false);
      props.setDrawer(false);
      setMeasurementData();
      setNetPriceValue("");
    };

    const onChangeCollpase = (key) => {
      // console.log(key);
    };
  
    const calculateUpperTolerance = () => {
      if(plannedWeight && form.getFieldValue("upper_tolerance")){
        let upperTol = (plannedWeight * (100 + parseFloat(form.getFieldValue("upper_tolerance")))) /100;
        setUpperTolerance(parseFloat(upperTol).toFixed(3));
      } else{
        setUpperTolerance(0.000);
      }
    };
  
    const calculateLowerTolerance = () => {
      if(plannedWeight && form.getFieldValue("lower_tolerance")){
        let lowerTol = (plannedWeight * (100 - parseFloat(form.getFieldValue("lower_tolerance")))) /100 ;
        setLowerTolerance(parseFloat(lowerTol).toFixed(3));
      } else{
        setLowerTolerance(0.000);
      }
    };

    const calculateNetPrice = () => {
      let plannedWtConversion;
      if(plannedWeight && orderDetails?.quoted_price){
        if(unitPlaceholder?.toLowerCase() !== productData?.units?.per_weight_unit?.toLowerCase()){
          let unitToTonneConv = plannedWeight * weight_Unit_Conversions[unitPlaceholder];
          plannedWtConversion  = unitToTonneConv * conversionFactorTonneToUnits[productData?.units?.per_weight_unit];
        } else{
          plannedWtConversion  = plannedWeight;
        }
        const netPrice = parseFloat(orderDetails?.quoted_price) * parseFloat(plannedWtConversion)
        ? parseFloat(orderDetails?.quoted_price) * parseFloat(plannedWtConversion)
        : "";
          if (netPrice){
            setNetPriceValue(parseFloat(netPrice)?.toFixed(3));
          } else{
            setNetPriceValue("");
          }
      } else{
        setNetPriceValue("");
      }
    };

    const onUpperTolChange = (e) => {
      setDefaultUpperTol(e.target.value);
      form.setFieldsValue({upper_tolerance: e.target.value});
      if(plannedWeight && form.getFieldValue("upper_tolerance")){
        let upperTol = (plannedWeight * (100 + parseFloat(form.getFieldValue("upper_tolerance")))) /100;
        setUpperTolerance(parseFloat(upperTol).toFixed(3));
      } else{
        setUpperTolerance(0.000);
      }
    };
  
    const onLowerTolChange = (e) => {
      setDefaultLowerTol(e.target.value);
      form.setFieldsValue({lower_tolerance: e.target.value});
      if(plannedWeight && form.getFieldValue("lower_tolerance")){
        let lowerTol = (plannedWeight * (100 - parseFloat(form.getFieldValue("lower_tolerance")))) /100 ;
        setLowerTolerance(parseFloat(lowerTol).toFixed(3));
      } else{
        setLowerTolerance(0.000);
      }
    };

    useEffect(() => {
        if(numberOfPlannedReels){
            let size;
            let reelOD = form.getFieldValue("reel_od");
            let coreOD = form.getFieldValue("core_od");
            // let noOfReels = form.getFieldValue("no_of_reel_sheet");
            if(orderDetails?.type === "sheet"){
                size = orderDetails?.grain === "short" ? (parseFloat(orderDetails?.length) > parseFloat(orderDetails?.width) ? orderDetails?.length : orderDetails?.width) 
                : (parseFloat(orderDetails?.length) > parseFloat(orderDetails?.width) ? orderDetails?.width : orderDetails?.length);
            } else{
                size = orderDetails?.width;
            }
            if(reelOD && coreOD){
              calculatePlannedWeight(size, productData?.bulk, reelOD, coreOD, form.getFieldValue("no_of_reel_sheet"));
            }
        }
    },[numberOfPlannedReels]);

    useEffect(() => {
      (async () => {
      if(props?.selectedProduct){

        getProductDetails(props?.selectedProduct).then((response) => {
          setProductData(response?.data);
        }).catch((error) => {
            console.log("Error in getting product specification list");
        });

        try{
          const unitData = await getUnitData();
          if(!unitData.error){
            setMeasurementData(unitData);

            // form.setFieldsValue({unit: unitData.data.units_management.length.default});
            setReiwnderDimUnitList(unitData.data.units_management.length.data);
  
            // form.setFieldsValue({weightUnit: unitData.data.units_management.weight.default});
            setWeightUnitList(unitData.data.units_management.weight.data);
  
            // setUnitPlaceholder(unitData.data.units_management.weight.default);
          }
        } catch(err){
          console.log(err);
        }
    }
    })();
    },
    [props?.selectedProduct]
    );
  
    useEffect(() => {
          props.selectedOrderNo &&
            getAllOrdersListByOrderno(props.selectedOrderNo)
              .then((response) => {
                response.data.delivery_date = moment(response.data.delivery_date ).format("DD MM YYYY");
                setOrderDetails(response.data);
                setOrderNo(response.data.number);
              })
              .catch((error) => {
                console.log(error);
              });
          return () => setOrderDetails({});
        }, [productData]
    );

    useEffect(() => {
        if(orderDetails){
            setOrderQuantityTab([
                { label: "Weight", value: "weight" },
                { label: (orderDetails?.type ? `${capitalize(orderDetails?.type)}s` : orderDetails?.type+"s" ), value: orderDetails?.type},
            ]);
            if(orderDetails?.reel_diameter === "multiple"){
              setRewinderDia(true);
            }

          // form.setFieldsValue({core_od: orderDetails?.upper_tolerance});
          // form.setFieldsValue({reel_od: orderDetails?.lower_tolerance});
          setDefaultUpperTol(orderDetails?.upper_tolerance);
          setDefaultLowerTol(orderDetails?.lower_tolerance);
          form.setFieldsValue({upper_tolerance: orderDetails?.upper_tolerance});
          form.setFieldsValue({lower_tolerance: orderDetails?.lower_tolerance});
          setUpperTolerance(orderDetails?.calculated_upper_tolerance);
          setLowerTolerance(orderDetails?.calculated_lower_tolerance);
          
          
            if(orderDetails?.quantity_type == "weight"){
              setUnitPlaceholder(orderDetails?.units.weight? orderDetails?.units.weight : "t");
              form.setFieldsValue({weightUnit: orderDetails?.units.weight? orderDetails?.units.weight : "t"});
              setSplitQuantity("weight");
              setPendingQuantity("weight");
              calculatePendingQuantity("weight");
            } else{
              setUnitPlaceholder(measurementData?.data.units_management.weight.default);
              form.setFieldsValue({weightUnit: measurementData?.data.units_management.weight.default});
              setSplitQuantity(orderDetails?.type);
              setPendingQuantity(orderDetails?.type)
              calculatePendingQuantity(orderDetails?.type);
            }            
        }
    },[orderDetails]);
    
    useEffect(() => {
        if(pendingQuantity && orderDetails){
            calculatePendingQuantity(pendingQuantity);
        }
    },[pendingQuantity])

    useEffect(() => {
      calculateUpperTolerance();
      calculateLowerTolerance();
      calculateNetPrice();
    },[plannedWeight]);
        
    return (
      (orderNo && orderDetails && pendingQuantity) ? (
        <RightDrawerSidebar
          title={`Split Order - ${orderNo}`}
          subtitle=""
          visible={props.visible}
          onClose={handleClose}
        >
          <RightDrawerContainer>
            <div className="resetPassForm removePadLeft">
            {visibleToaster && (
            <AlertContainer
              setClose={setVisibleToaster}
              color={actionToaster.error ? "red" : "green"}
              icon={actionToaster.error ? alertRed : alertGreen}
              msg={actionToaster.msg}
              closeIcon={true}
            />
          )}
              <DetailFields className="marginBtnP">
                <HaberForm>
                  <Form
                    name="basic"
                    autoComplete="off"
                    className="haberLogin haberSignup"
                    style={{ marginTop: "5px" }}
                    onFinish={onFinish}
                    form={form}
                  >
                    <div className="drawerField">
                      <div className="titleWithText">
                        <h5>Order Details</h5>
                        <p style={{ marginBottom: "0px" }}>
                          Dimension :{" "}
                          {orderDetails.type == "reel"
                            ? (orderDetails.width + " " +(orderDetails?.units && orderDetails?.units?.width? lengthUnit[orderDetails.units?.width]?.displayName.toUpperCase() : "CM"))
                            : (orderDetails.width + " X " +
                              orderDetails.length + " " + (orderDetails?.units && orderDetails?.units?.width? lengthUnit[orderDetails.units?.width]?.displayName.toUpperCase() : "CM"))}
                        </p>
                        {" "}
                        <p style={{ marginBottom: "0px" }}>
                          Type : {orderDetails?.type ? capitalize(orderDetails?.type) : " "}{" "}
                          {orderDetails?.grain
                            ? "(" + capitalize(orderDetails?.grain) + " Grain)"
                            : ""}
                        </p>
                         <p>Product Spec : {orderDetails?.product_spec}</p>
                      </div>
                    </div>
                    <div className="drawerField">
                      <div className="titleWithText">
                        <h5>Pending Quantity</h5>
                        <p>
                          The quantity of the order pending to be processed in
                          deckle
                        </p>
                      </div>
                      <div
                        className=" switchRadio twoSwitch"
                        style={{ justifyContent: "center", display: "flex" }}
                      >
                        <Radio.Group
                          options={orderQuantityTab}
                          disabled={true}
                          optionType="button"
                          buttonStyle="solid"
                          value={pendingQuantity}
                        />
                      </div>
                      {(pendingQuantity === "weight") ? (
                        <>
                          <div className="subTitleWithText">
                            <p></p>
                          </div>
                          <div style={{ position: "relative" }}>
                            <Form.Item
                              name="pendingWeight"
                              className=""
                              initialValue=""
                            >
                              <Input disabled placeholder="Enter weight" />
                            </Form.Item>
                            <span className="nonEditable">{orderDetails?.units && orderDetails.units.weight  ? capitalize(weightUnit[orderDetails.units.weight]?.displayName) : ""}</span>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="subTitleWithText">
                            <p></p>
                          </div>
                          <div style={{ position: "relative" }}>
                            <Form.Item
                              name="pendingReels"
                              className=""
                              initialValue=""
                            >
                              <Input disabled placeholder="Enter quantity" />
                            </Form.Item>
                          </div>
                        </>
                      )}
                    </div>
                    <div className="drawerField">
                      <div className="titleWithText">
                        <h5>Split Quantity</h5>
                        <p>The quantity of the order to be split</p>
                      </div>
                      <div
                        className=" switchRadio twoSwitch"
                        style={{ justifyContent: "center", display: "flex" }}
                      >
                        <Radio.Group
                          options={orderQuantityTab}
                          disabled={pendingQuantityIsZero || splitQuantity !==""}
                          optionType="button"
                          buttonStyle="solid"
                          value={splitQuantity}
                        />
                      </div>
                      {(splitQuantity === "weight") ? (
                        <>
                          <div className="subTitleWithText">
                            <p></p>
                          </div>
                          <div style={{ position: "relative" }}>
                            <Row className="centerAlign justifyCSBetween">
                            <Col span={13}>
                              <div className="boxFormType">
                                <Form.Item
                                name="splitWeight"
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                  {
                                    pattern: new RegExp(/^\d+(\.\d{0,3})?$/),
                                    message:
                                      "Upto 3 decimal point value is accepted",
                                  },
                                  // {
                                  //   validator: (_, value) => {
                                  //     if (splitQuantityWeightValidationError) {
                                  //       return Promise.reject(
                                  //         "Split quantity cannot be greater than pending quantity."
                                  //       );
                                  //     } else if (
                                  //       splitQuantityWghtValidationError
                                  //     ) {
                                  //       return Promise.reject(
                                  //         "Split quantity cannot be 0."
                                  //       );
                                  //     } else {
                                  //       return Promise.resolve();
                                  //     }
                                  //   },
                                  // },
                                ]}
                                className=""
                                >
                                  <Input
                                  disabled={pendingQuantityIsZero}
                                  placeholder="Enter weight"
                                  onChange={validateSplitWeight}
                              />
                                </Form.Item>
                              </div>                              
                            </Col>
                            <Col span={10}>
                              <div className="boxFormType ">
                                <Form.Item
                                name="weightUnit"
                                rules={[
                                  {
                                    required: true,
                                    message: "This field is required",
                                  },
                                ]}
                                className="dBlock"
                              >
                                <Select
                                  placeholder="Unit"
                                  suffixIcon={<DownArrowDraw />}
                                  onChange={onChangeWeightUnit}
                                >
                                  {weightUnitList?.map((unitItem) => (
                                    <Option key={unitItem} value={unitItem}>
                                     {weightUnit[unitItem]?.displayName}
                                    </Option>
                                  ))}
                                </Select>
                                </Form.Item>
                              </div>
                            </Col>
                            {splitQuantityWeightValidationError ? (
                              <span
                                className="errorText"
                                style={{ color: "#ea4e2c", marginTop:"-13px" }}
                              >
                                Split quantity cannot be greater than pending quantity
                              </span>
                            ) : splitQuantityWghtValidationError ? ( 
                              <span
                                className="errorText"
                                style={{ color: "#ea4e2c", marginTop:"-13px" }}
                              >
                                Split quantity cannot be 0
                              </span>
                            ) : null}
                          </Row>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="subTitleWithText">
                            <p></p>
                          </div>
                          <div style={{ position: "relative" }}>
                            <Form.Item
                              name="splitQuantity"
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required.",
                                },
                                {
                                  pattern: new RegExp(/^\d+(\.\d+)?$/),
                                  message:
                                    "Only decimal characters are allowed.",
                                },
                                {
                                  validator: (_, value) => {
                                    if (splitQuantError) {
                                      return Promise.reject(
                                        "Split quantity cannot be greater than pending quantity."
                                      );
                                    }
                                    else if (splitQuantityValidationError) {
                                      return Promise.reject(
                                        "Split quantity cannot be 0."
                                      );
                                    } else {
                                      return Promise.resolve();
                                    }
                                  },
                                },
                              ]}
                              className=""
                            >
                              <Input
                                disabled={pendingQuantityIsZero}
                                placeholder="Enter quantity"
                                onChange={validateSplitQuantity}
                              />
                            </Form.Item>
                          </div>
                        </>
                      )}
                    </div>
                    <div className="drawerField removeStar">
                      <div className="titleWithText">
                        <h5>Rewinder Dimensions</h5>
                        <p>The outer diameter of the reel and rewinder core</p>
                      </div>
                      <Col span={24}>
                        <Row className="centerAlign  justifyCSBetween">
                          <Col span={8} className="blockBreak">
                            <div
                              className="boxFormType"
                              style={{ marginBottom: "0" }}
                            >
                              <Form.Item
                                label="Core OD"
                                name="core_od"
                                rules={[
                                  {
                                    pattern: new RegExp(/^\d+(\.\d+)?$/),
                                    message: "Only Numeric value is possible",
                                  },
                                ]}
                                className="dBlock"
                                initialValue={orderDetails?.core_id}
                              >
                                <Input
                                  placeholder="Core OD"
                                  disabled={!rewinderDia}
                                  onChange={validateCoreOd}
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col span={8} className="blockBreak">
                            <div className="boxFormType">
                              <Form.Item
                                label="Reel OD"
                                name="reel_od"
                                rules={[
                                  {
                                    pattern: new RegExp(/^\d+(\.\d+)?$/),
                                    message: "Only Numeric value is possible",
                                  },
                                ]}
                                className="dBlock"
                                initialValue={orderDetails?.reel_od}
                              >
                                <Input
                                  placeholder="Reel OD"
                                  disabled={!rewinderDia}
                                  onChange={validateReelOd}
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          <Col span={7} className="blockBreak">
                            <div className="boxFormType unitSelect">
                              <Form.Item
                                label="Unit"
                                name="unit"
                                className="dBlock"
                                initialValue={(orderDetails?.units && orderDetails?.units?.reel_od) ? orderDetails?.units?.reel_od : "cm"}
                              >
                                <Select
                                  disabled={!rewinderDia}
                                  placeholder="Unit"
                                  suffixIcon={<DownArrowDraw />}
                                  className="dBlock"
                                  onChange={onChangeCoreUnit}
                                >
                                  {rewinderDimUnitList?.map((deckleWidth) => (
                                    <Option
                                      key={deckleWidth}
                                      value={deckleWidth}
                                    >
                                      {deckleWidth}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </div>
                          </Col>
                          {coreOdValidationError ? (
                        <span
                          className="errorText"
                          style={{ color: "#ea4e2c", marginTop:"-10px" }}
                        >
                          Reel OD cannot be less than Core OD
                        </span>
                      ) : null}
                        </Row>
                      </Col>
                    </div>
                    {((orderDetails?.type === "sheet" && form.getFieldValue("core_od") && form.getFieldValue("reel_od")) ||
                    (orderDetails?.type === "reel")) && <div className="drawerField">
                      <div className="titleWithText">
                        <h5>Planned Number of Rewinder Reels</h5>
                      </div>
                      <div className="redTitleWithText">
                        {splitQuantity !== "reel" && (
                          <h3>{`Calculated number of reels is: ${numberOfPlannedReels}`}</h3>
                        )}
                        <p>
                          The number of reels specified below will be considered
                          for production
                        </p>
                      </div>
                      <Form.Item
                        name="no_of_reel_sheet"
                        rules={[
                          {
                            pattern: new RegExp(/^\d+(\.\d+)?$/),
                            message: "Only Numeric value is possible",
                          },
                        ]}
                        className=""
                      >
                        <Input
                          placeholder="Enter the number of reels"
                          onChange={onNoOfReelSheetChange}
                        />
                      </Form.Item>
                    </div>}
                    <div className="drawerField">
                      <div className="titleWithText">
                        <h5>Planned Weight</h5>
                        <p style={{ marginBottom: "3px" }}>
                          Calculated weight for planned number of reels
                        </p>
                      </div>
                      <div style={{ position: "relative" }}>
                        <Form.Item
                          name="planned_weight"
                          rules={[]}
                          className=""
                        >
                          <Input placeholder="Planned Weight" disabled />
                        </Form.Item>
                        <span className="nonEditable">{weightUnit[unitPlaceholder]?.displayName}</span>
                      </div>
                    </div>
                    {((orderDetails?.type === "sheet" || form.getFieldValue("type") === "sheet") && 
                    ((!form.getFieldValue("core_od") && !form.getFieldValue("reel_od")) || (!orderDetails?.core_id &&  !orderDetails?.reel_od))) ?
                      (<Collapse 
                      onChange={onChangeCollpase}
                      expandIconPosition="right"
                      bordered={false}
                      style={{backgroundColor: "white", marginTop:"-18px"}}>
                      <Panel
                        header={"Tolerance -" + defaultUpperTol + " to +"+ defaultLowerTol +" %"}
                        style={{ fontStyle: "italic" , marginLeft:"-12px"}}
                      >
                        <Row
                            style={{ marginTop: "3px" }}
                            className="centerAlign  justifyCSBetween"
                          >
                            <Col span={8} className="blockBreak">
                              <div className="titleWithText">
                                <p style={{marginTop:"7px", fontStyle: "initial", fontSize: "12px", fontFamily: "var(--sf-pro-text)",
                                 color: "var(--color-text-title)", lineHeight: "20px", }}>Upper Tolerance </p>
                              </div>
                            </Col>
                            <Col span={8} className="blockBreak">
                              <div
                                className="boxFormType"
                                style={{ marginBottom: "0" }}
                              >
                                <Form.Item
                                  label=""
                                  name="upper_tolerance"
                                  rules={[
                                    {
                                      pattern: new RegExp(/^\d+(\.\d{0,5})?$/),
                                      message: "Only Numeric value is possible",
                                    },
                                    {
                                        required: true,
                                        message: "This field is required",
                                    },
                                  ]}
                                  className="dBlock"
                                  initialValue={defaultUpperTol}
                                  onChange={(e) => {
                                    onUpperTolChange(e);
                                  }}
                                >
                                  <Input
                                    placeholder=""
                                    style={{fontSize:"10px",height:"30px"}}
                                    // disabled={true}
                                  />
                                </Form.Item>
                                <span className="nonEditable" style={{fontize: "13px", top:"5px"}}>%</span>
                              </div>
                            </Col>
                            <Col span={8} className="blockBreak">
                            <Col span={8} className="blockBreak" style={{maxWidth:"45%", marginLeft:"15px"}}>
                              <div className="titleWithText">
                                <p style={{fontSize: "12px", fontFamily: "var(--sf-pro-text)",
                                 color: "var(--color-text-title)", lineHeight: "20px",

                                  marginTop:"7px",fontStyle: "initial", width:"104px"}}>{upperTolerance}{" "} {weightUnit[unitPlaceholder]?.displayName}</p>
                              </div>
                            </Col>
                            </Col>
                        </Row>
                        <Row
                            style={{ marginTop: "0px" }}
                            className="centerAlign  justifyCSBetween"
                          >
                            <Col span={8} className="blockBreak">
                              <div className="titleWithText">
                                <p style={{marginTop:"7px", fontStyle: "initial", fontSize: "12px", fontFamily: "var(--sf-pro-text)",
                                 color: "var(--color-text-title)", lineHeight: "20px", }}>Lower Tolerance </p>
                              </div>
                            </Col>
                            <Col span={8} className="blockBreak">
                              <div
                                className="boxFormType"
                                style={{ marginBottom: "0" }}
                              >
                                <Form.Item
                                  label=""
                                  name="lower_tolerance"
                                  rules={[
                                    {
                                      pattern: new RegExp(/^\d+(\.\d{0,5})?$/),
                                      message: "Only Numeric value is possible",
                                    },
                                    {
                                        required: true,
                                        message: "This field is required",
                                    },
                                  ]}
                                  className="dBlock"
                                  initialValue={defaultLowerTol}
                                  onChange={(e) => {
                                    onLowerTolChange(e);
                                  }}
                                >
                                  <Input
                                    placeholder=""
                                    style={{fontSize:"10px", height:"30px"}}
                                    // disabled={true}
                                  />
                                </Form.Item>
                                <span className="nonEditable" style={{fontize: "13px", top:"5px"}}>%</span>
                              </div>
                            </Col>
                            <Col span={8} className="blockBreak">
                            <Col span={8} className="blockBreak" style={{maxWidth:"45%", marginLeft:"15px"}}>
                              <div className="titleWithText">
                                <p style={{fontSize: "12px", fontFamily: "var(--sf-pro-text)",
                                 color: "var(--color-text-title)", lineHeight: "20px",
                                  marginTop:"7px",fontStyle: "initial", width:"104px"}}>{lowerTolerance}{" "} {weightUnit[unitPlaceholder]?.displayName}</p>
                              </div>
                            </Col>
                            </Col>
                          </Row>
                        </Panel>
                      </Collapse>) : (null)                   
                    }

                    <div className="drawerField">
                      <div className="titleWithText">
                        <h5>Delivery Date</h5>
                        <p>Date when this quantity needs to be delivered</p>
                      </div>
                      <div className="boxFormType">
                        <DatePickerY>
                          <Form.Item
                            name="delivery_date"
                            initialValue={moment(
                              orderDetails.delivery_date,
                              "DD MM YYYY"
                            )}
                            rules={[
                              {
                                required: true,
                                message: "This field is required",
                              },
                            ]}
                          >
                            <DatePicker
                              format={"DD/MM/YYYY"}
                              disabledDate={(current) => {
                                return (
                                  current &&
                                  current < moment().subtract(1, "day")
                                );
                              }}
                            />
                          </Form.Item>
                        </DatePickerY>
                      </div>
                    </div>
                    <div className="drawerField">
                      <div className="titleWithText">
                        <h5>Remarks</h5>
                        <p>Any other Information related to the order</p>
                      </div>
                      <Form.Item name="remarks" className="">
                        <TextArea
                          maxLength={100}
                          style={{ height: 90 }}
                          placeholder="Add Remarks"
                        />
                      </Form.Item>
                    </div>
                    <div className="buttonFlex fixedBtm">
                      <Form.Item>
                        <Button htmlType="submit" className="themeBtn">
                          <Iconmoon
                            icon={"Mapping"}
                            size={17}
                            color="#FFFFFF"
                          />
                          Split Order
                        </Button>
                      </Form.Item>
                      <Form.Item>
                        <Button
                          key="3"
                          className="textTypeBtn"
                          onClick={handleClose}
                        >
                          Cancel changes
                        </Button>
                      </Form.Item>
                    </div>
                  </Form>
                </HaberForm>
              </DetailFields>
            </div>
          </RightDrawerContainer>

          <ModalPopup visible={isVisibleModal}>
        <div className="Popup-img">
          <img src={warning} alt="Warning" />
        </div>
        <div className="Popup-content">
          <span>Split Order ?</span>
          <p>
          The mentioned quantity will be split into a new order. You can view both orders in the order group formed after splitting. Are you sure you want to continue?
          </p>
        </div>
        <div className="ant-modal-footer-section">
          <Button
            key="back"
            className="themeBtn-plane"
            onClick={() => modalClose()}
          >
            <div className="plusPopUpBorder">
              <Iconmoon
                icon="plus-sign"
                size={9}
                color="#EA655B"
                className="ant-ico-sec"
              />
            </div>
            Cancel
          </Button>

          <Button
            key="submit"
            className="themeBtn"
            onClick={() => modalConfirm()}
          >
            <Iconmoon icon="tick-mark" size={14} color="#ffff" />
            Confirm
          </Button>
        </div>
      </ModalPopup>
        </RightDrawerSidebar>
      ) : null
    ) ;
};
export default SplitOrderDrawer;